module.exports = __webpack_public_path__ + "img/special-img-2.1918ed2a.svg";